<template>
  <div class="container-fluid">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <ValidationProvider
          :name="$t('modal.form.name.label')"
          rules="required"
          v-slot="{ errors }"
        >
          <label>
            {{ $t('modal.form.name.label') }}
            <input 
              v-model="form.name"
              type="text"
              :placeholder="$t('modal.form.name.placeholder')"
            >

            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <ValidationProvider
          :name="$t('modal.form.name_ru.label')"
          rules="required"
          v-slot="{ errors }"
        >
          <label>
            {{ $t('modal.form.name_ru.label') }}
            <input 
              v-model="form.name_ru"
              type="text"
              :placeholder="$t('modal.form.name_ru.placeholder')"
            >

            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <ValidationProvider
          :name="$t('modal.form.address.label')"
          rules="required"
          v-slot="{ errors }"
        >
          <label>
            {{ $t('modal.form.address.label') }}
            <input 
              v-model="form.address"
              type="text"
              :placeholder="$t('modal.form.address.placeholder')"
            >

            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <label>
          {{ $t('modal.form.image.label') }}
          <input 
            required
            type="file"
            @change="getImageFile"
          >
        </label>

        <ValidationProvider
          :name="$t('modal.form.branch.label')"
          rules="required"
          v-slot="{ errors }"
        >
          <label>
            {{ $t('modal.form.branch.label') }}

            <v-select 
              v-model="form.branch_id"
              :options="branches_select"
            ></v-select>

            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <ValidationProvider
          :name="$t('modal.form.region.label')"
          rules="required"
          v-slot="{ errors }"
        >
          <label>
            {{ $t('modal.form.region.label') }}
            
            <v-select 
              v-model="form.region_id"
              :options="options"
            ></v-select>

            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>
        
        <b-button class="float-end ms-3"
          variant="primary"
          type="submit" :disabled="dButton"
        >
          {{ $t('modal.button.put') }}
        </b-button>

        <b-button class="float-end"
          variant="warning"
          @click="onClose"
        >
          {{ $t('modal.button.back') }}
        </b-button>

      </form>
    </ValidationObserver>
  </div>
</template>

<script>
  import { getWarehouseID, putWarehouse, getWarehouse } from '../../../api/endpoints/warehouse'
  import { listMixin } from '../../../mixins/listMixin';
  import { getBranchID } from '../../../api/endpoints/branches' 

  const req = {
    get_id: getWarehouseID,
    put: putWarehouse,
    get: getWarehouse,
  }

  export default {
    name: "WarehousePutModal",
    props: {
      id: {
        type: Number,
        required: true
      },
      branches_select: {
        type: Array,
        required: true
      }
    },
    mixins: [listMixin],
    data() {
      return {
        req,
        form: {
          name: "",
          name_ru: "",
          address: "",
          branch_id: null,
          region_id: null,
        },
        options: [
          {value: 1, label: "Yashnaobod"},
        ],
        imageFile: null,
        fd: new FormData(),
        dButton: false,
      }
    },
    methods: {
      branchSearch() {
        getBranchID(this.form.branch_id).then( res => {
          this.form.branch_id = {value: res.data.data.id, label: res.data.data.name}
        })
      },
      regionsSearch() {
        this.form.region_id = {value: 1, label: "Yashnaobod"}
      },
      getImageFile(e) {
        this.imageFile = e.target.files
      },
      onSubmit() {
        this.dButton = true;
        setTimeout(() => {
          this.dButton = false;
        }, 700)
        for(let label in this.form) {
          this.fd.append(label, this.form[label])
        }
        this.fd.append('branch_id', this.form.branch_id.value)
        this.fd.append('region_id', this.form.region_id.value)
        this.fd.append('image', this.imageFile[0])
        this.fd.append('_method','PUT')

        this.onPut()
      },
      onClose() {
        this.$emit('onClose')
      }
    },
    watch: {
      id: {
        immediate: true,
        handler() {
          this.onFetchByID().then( () => {
            this.branchSearch();
            this.regionsSearch()
          })
        }
      }
    }
  }
</script>